import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=8988d996&scoped=true"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"
import style0 from "./SearchComponent.vue?vue&type=style&index=0&id=8988d996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8988d996",
  null
  
)

export default component.exports